var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArtOtp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.623-58.698-60.689 1.531-27.357 38.565-27.82 64.193-37.512",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F8B24F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m88 85.94 26.946-8.178M103 116.172l17.4-5.499M78 104.997l36.734-10.178"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 120,
  x: 119,
  y: 37.155,
  fill: "#3863F0",
  rx: 12,
  transform: "rotate(-10 119 37.155)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 112,
  x: 123.634,
  y: 40.4,
  fill: "#fff",
  rx: 8,
  transform: "rotate(-10 123.634 40.4)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 4,
  x: 166.487,
  y: 139.464,
  fill: "#3863F0",
  rx: 2,
  transform: "rotate(-10 166.487 139.464)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 32,
  x: 153,
  y: 60,
  fill: "#F56B57",
  rx: 16
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M170.046 81.908q-.566-.345-.659-.88-.095-.533.314-1.13l2.009-3.077.565.816-3.674.189q-.721.03-1.161-.283-.44-.345-.44-1.005 0-.628.44-.973.44-.346 1.161-.283l3.674.22-.533.816-2.01-3.108q-.408-.628-.314-1.162.095-.534.659-.848.534-.346 1.068-.094.534.25.848.91l1.444 3.015h-.471l1.445-3.015q.314-.66.848-.91.533-.251 1.099.094.565.345.628.88.094.533-.314 1.161l-2.01 3.046-.534-.785 3.674-.22q.723-.062 1.162.283.44.346.44.973 0 .66-.44 1.005-.44.315-1.162.283l-3.674-.189.534-.816 2.01 3.077q.407.597.314 1.13-.063.504-.628.848-.597.346-1.131.126-.503-.25-.816-.91l-1.445-3.046h.471l-1.476 3.045q-.314.66-.847.911-.503.22-1.068-.094M184.275 81.908q-.566-.345-.66-.88-.094-.533.314-1.13l2.01-3.077.565.816-3.674.189q-.721.03-1.162-.283-.44-.345-.439-1.005 0-.628.439-.973.44-.346 1.162-.283l3.674.22-.534.816-2.009-3.108q-.408-.628-.314-1.162t.659-.848q.534-.346 1.068-.094.534.25.848.91l1.444 3.015h-.471l1.445-3.015q.314-.66.847-.91.535-.251 1.099.094.566.345.628.88.095.533-.314 1.161l-2.009 3.046-.534-.785 3.674-.22q.722-.062 1.162.283.44.346.439.973 0 .66-.439 1.005-.44.315-1.162.283l-3.674-.189.534-.816 2.009 3.077q.409.597.314 1.13-.062.504-.628.848-.596.346-1.13.126-.502-.25-.816-.91l-1.445-3.046h.471l-1.476 3.045q-.314.66-.848.911-.502.22-1.067-.094M198.504 81.908q-.566-.345-.66-.88-.094-.533.314-1.13l2.01-3.077.565.816-3.674.189q-.722.03-1.162-.283-.44-.345-.439-1.005 0-.628.439-.973.44-.346 1.162-.283l3.674.22-.534.816-2.009-3.108q-.409-.628-.314-1.162.093-.534.659-.848.534-.346 1.068-.094.533.25.847.91l1.445 3.015h-.471l1.444-3.015q.315-.66.848-.91.534-.251 1.099.094t.628.88q.094.533-.314 1.161l-2.009 3.046-.534-.785 3.674-.22q.722-.062 1.162.283.44.346.439.973 0 .66-.439 1.005-.44.315-1.162.283l-3.674-.189.534-.816 2.009 3.077q.408.597.314 1.13-.063.504-.628.848-.596.346-1.13.126-.502-.25-.817-.91l-1.444-3.046h.471l-1.476 3.045q-.314.66-.848.911-.503.22-1.067-.094M212.732 81.908q-.564-.345-.659-.88-.094-.533.314-1.13l2.01-3.077.565.816-3.674.189q-.723.03-1.162-.283-.44-.345-.44-1.005 0-.628.44-.973.44-.346 1.162-.283l3.674.22-.534.816-2.01-3.108q-.407-.628-.314-1.162.094-.534.66-.848.534-.346 1.067-.094.534.25.848.91l1.445 3.015h-.471l1.444-3.015q.315-.66.848-.91.534-.251 1.099.094t.628.88q.094.533-.314 1.161l-2.01 3.046-.533-.785 3.674-.22q.721-.062 1.161.283.44.346.44.973 0 .66-.44 1.005-.44.315-1.161.283l-3.674-.189.533-.816 2.01 3.077q.408.597.314 1.13-.063.504-.628.848-.597.346-1.13.126-.502-.25-.817-.91l-1.444-3.046h.471l-1.476 3.045q-.314.66-.848.911-.502.22-1.068-.094"
})));
export default SvgArtOtp;